import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const AUTOPLAY_DELAY_MS = 6000;

export function initCaseStudiesPageHeroQuotes() {
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	document.querySelectorAll('.js-cs-page-hero').forEach((section) => {
		const el = section.querySelector('.js-cs-page-hero-quotes');
		const pagination = section.querySelector('.js-cs-page-hero-quotes-pagination');
		const slides = el?.querySelectorAll('.swiper-slide') ?? [];

		if (!el || el.swiper || slides.length < 2) {
			if (slides.length < 2) {
				pagination?.setAttribute('hidden', 'hidden');
			}
			return;
		}

		// Deliberately NOT switched to cssMode on touch like every other
		// carousel on the site (see client-testimonials-swiper.js): cssMode is
		// incompatible with loop, and this autoplay quote rotator needs loop.
		// It's slidesPerView: 1 with no user-driven deep scrolling, so the
		// WebKit transform-recomposite bugs the others hit don't apply here.
		new Swiper(el, {
			modules: [Pagination, Autoplay],
			slidesPerView: 1,
			spaceBetween: 24,
			watchOverflow: true,
			// Keep the drag on the carousel instead of losing it to iOS
			// Safari's edge swipe-back gesture (#128).
			edgeSwipeDetection: 'prevent',
			loop: true,
			autoplay: prefersReducedMotion
				? false
				: {
						delay: AUTOPLAY_DELAY_MS,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
					},
			pagination: {
				el: pagination,
				clickable: true,
			},
		});
	});
}
